import { Fragment } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

const CVCfour = () => {
  const info = [
    'Liên quan đến việc chèn ống thông qua tĩnh mạch dưới đòn hoặc tĩnh mạch cổ bên trong, các biến chứng tiềm ẩn có thể bao gồm thủng động mạch dưới đòn, tổn thương thần kinh\n    cánh tay, phế quản, lưu thông máu, xuất huyết do thủng dây dẫn của các mạch lân cận, băng vệ tim, thủng tim, loạn nhịp tim và các vấn đề liên quan đến thiết bị. Nếu thực hiện chèn\n    qua tĩnh mạch đùi, có thể xảy ra các biến chứng như thủng động mạch đùi, chảy máu âm đạo hoặc chảy ngược màng bụng.',
    'Sau khi chèn, có nguy cơ nhiễm khuẩn, hình thành cục máu đông trong mạch máu trong ống thông, và chứng huyết khối hoặc hẹp mạch máu tại vị trí chèn ống thông.',
    'Bạn nên đặt một túi cát để cầm máu trên vùng thủng tĩnh mạch và vùng rạch da trong hai giờ. Trong giai đoạn này, giảm thiểu thay đổi vị trí.',
    'Vết bầm hoặc sưng ở chỗ chèn ống thông sẽ lắng xuống trong vòng vài ngày.',
    'Trong quá trình chèn hoặc sử dụng ống thông, có thể xảy ra các biến chứng như tràn khí màng phổi,tràn máu màng  phổi, tích tụ dịch, và tắc mạch khí.',
    'Nếu có sự thay đổi về vị trí hoặc tắc ống thông trong quá trình sử dụng, cần phải kiểm tra và nếu có nhiễm trùng liên quan đến ống thông thì nên loại bỏ ống thông.',
    'Cần băng gạc để ngăn ngừa nhiễm trùng tại vị trí chèn và thường xuyên tiêm nước muối vô trùng để ngăn chặn tắc ống thông.',
  ];

  return (
    <Fragment>
      <SectionTitle title="4. Những biện pháp phòng ngừa sau phẫu thuật" />
      <Box sx={{ margin: '38px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          {info.map((a, i) => {
            return (
              <Grid item xs={11.5}>
                <Typography
                  sx={{
                    fontSize: '14px',
                    lineHeight: '30px',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  • {a}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Fragment>
  );
};

export default CVCfour;
